<template>
  <PageHeader
    title="Folkszemle"
    hero-class="bg-folkszemle hidden lg:flex"
    :breadcrumb="[ 'Folkszemle','Cikkek']"
  >
    <div
      class="flex flex-col lg:flex-row gap-x-6"
      @keyup.enter="$refs.search.submit()"
    > 
      <div class="min-w-0 w-full lg:static lg:max-h-full lg:overflow-visible ">
        <client-only>
          <search
            ref="search"
            :query-object="queryObject"
            :prop-mapping="{
              themes: 'themes.type',
              author: 'collaborators.name',
              editor: 'collaborators.name'
            }"
            class="bg-white p-[25px]  mb-5"
            @searchChanged="searchChanged($event)"
          />
        </client-only>
        <div 
          ref="entitiesList"
          class="bg-white w-full mt-7"
        >
          <ReOverlayLoader :loading="$fetchState.pending || isLoading">
            <RePagination
              :items="entities"
              :hide-page-selector="true"
              result-title="Cikkek száma"
            />
            <div
              v-if="entities.total === 0"
              class="mt-10"
            >
              <p class="text-center">
                A megadott feltételekkel nem található cikk a tallózóban.
              </p>
            </div>
            <div
              v-else
              class="flex flex-col gap-6 p-4 lg:px-10 lg:pt-10 place-items-center"
            >
              <nuxt-link
                v-for="(item) in entities.data"
                :key="item.id "
                class="group w-full"
                :class="{ 'opacity-30': item.status !== 'active' }"
                :to="'/folkszemle/cikk/' + item.id + '/' + item.slug"
              >
                <EntityRow 
                  :image="getMainImgObj(item)"
                  :no-box-slot="true"
                  has-image-padding
                  has-image-subtitle
                  :image-subtitle="(item.thumbnail.title ? (item.thumbnail.title + '<br>') : '') + (item.thumbnail.subtitle ? item.thumbnail.subtitle : '')"
                >
                  <template #body>
                    <div class="flex flex-row w-full h-full">
                      <div class="flex flex-col w-full">
                        <h2 class="font-source-serif-pro text-3xl font-semibold text-red group-hover:text-yellow">
                          {{ item.title }}
                        </h2>
                        <p
                          v-if="item.subtitle"
                          class="font-semibold block"
                        >
                          {{ item.subtitle }}           
                        </p>
                        <p
                          v-if="authors(item).length > 0"
                          class="block"
                        >
                          <span
                            v-for="(author,index) in authors(item)"
                            :key="author.name"
                            class="author"
                          >{{ author.name }} <span v-if="index !== authors(item).length-1"> &ndash; </span></span>
                        </p>

                        <p
                          v-if="editors(item).length > 0"
                          class="block"
                        >
                          <span>Szerkesztette:</span>
                          <span
                            v-for="(editor, index) in editors(item)"
                            :key="editor.name"
                          >{{ editor.name }}<span v-if="index !== editors(item).length-1"> &ndash; </span></span>
                        </p>
                      
                        <p class="my-[10px]">
                          {{ item.description }}
                        </p>
                        <!-- TODO: ezt atadni kepalairasnak -->
                        <!-- <p
                          v-if="item.thumbnail"
                          class="text-center d-none d-lg-block"
                        >
                          <span>{{
                            item.thumbnail.title ? item.thumbnail.title : ""
                          }}</span>
                          <br>
                          <span>{{
                            item.thumbnail.subtitle ? item.thumbnail.subtitle : ""
                          }}</span>
                        </p> -->


                        <div
                          v-if="item.themes_list && item.themes_list.length > 0"
                          class="tags"
                        >
                          <div class="flex  items-stretch">
                            <img
                              class="self-start mt-1 lg:mt-[2px]"
                              src="/img/bookmark_icon.svg"
                              alt=""
                            >
                            <ul class="text-[#A4A4A4] flex flex-col lg:flex-row">
                              <li
                                v-for="(item2, index2) in item.themes_list"
                                :key="index2"
                                class="inline hover:text-gray mr-2"
                              >
                                <nuxt-link :to="'/tallozo?search=themes.type:' + item2.type">
                                  {{ item2.type + (index2 == item.themes_list.length - 1 ? '' : ',') }} 
                                </nuxt-link>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </EntityRow>
              </nuxt-link>
            </div>
          </ReOverlayLoader>
        </div>
      </div>
      <client-only>
        <div class="inset-0 lg:w-72">
          <QuoteWindow
            v-if="findSidebarModule('quote_module') !== null"
            :class="'col order-' + findSidebarModule('quote_module')"
          />
          <KnowledgeWindow
            v-if="findSidebarModule('knowledge_module') !== null"
            :class="'col order-' + findSidebarModule('knowledge_module')"
          />
        </div>
      </client-only>
    </div>
  </PageHeader>
</template>
<script>
import { cloneDeep } from "lodash";
import Loader from "~/components/core/loader.vue";
import PageHeader from "~/components/folkradio/PageHeader.vue";
import search from "~/components/folkradio/searches/ArticleSearch.vue";
import ReOverlayLoader from "~/components/rxt/recomponent/ReOverlayLoader.vue";
import EntityRow from '~/components/folkradio/EntityRow.vue'
import scrollMixin from "~/mixins/scroll-fetch"

const RePagination = () =>
  import("~/components/rxt/recomponent/RePagination.vue");
const QuoteWindow = () => ({
  component: import('~/components/pages/sidebar/QuoteWindow.vue'),
  loading: Loader
})
const KnowledgeWindow = () => ({
  component: import('~/components/pages/sidebar/KnowledgeWindow.vue'),
  loading: Loader
})
export default {
  components: {
    RePagination,
    search,
    QuoteWindow,
    KnowledgeWindow,
    PageHeader,
    ReOverlayLoader,
    EntityRow
  },
  filters: {
    removeHtml (value) {
      // const div = document.createElement('div')
      // div.innerHTML = value
      // return div.textContent || div.textContent || ''
      return value !== null ? value.replace(/<[^>]*>?/gm, '') : ''
    }
  },
  mixins: [scrollMixin],
  head() {
    return {
      titleTemplate: "Folkszemle | Folkrádió",
      meta: [
        { hid: "title", name: "title", content: "Folkszemle | Folkrádió" },
        {
          hid: "og:title",
          name: "og:title",
          content: "Folkszemle | Folkrádió"
        },
        {
          hid: "description",
          name: "description",
          content: "Népzenéről és néptáncról szóló online ismeretterjesztés"
        },
        {
          hid: "og:description",
          name: "og:description",
          content: "Népzenéről és néptáncról szóló online ismeretterjesztés"
        },
        {
          hid: "og:site_name",
          name: "og:site_name",
          content: this.$getDomain() + "/folkszemle"
        },
        {
          hid: "og:site-name",
          name: "og:site-name",
          content: this.$getDomain() + "/folkszemle"
        },
        {
          hid: "og:image",
          name: "og:image",
          property: "og:image",
          content: this.$getDomain() + "/img/meta_default.png"
        }
      ]
    };
  },
  data() {
    return {
      quote: null,
      firstQuote: false,
      queryUrl: '/articles'
    };
  },
  watch: {
    $route(to, from) {
      this.$store.commit("search/setQueryObject", to.query);
      this.entities = {
        data: []
      }
      this.$fetch();
    }
  },
  fetchOnServer: false,
  async fetch() {
    let queryObject = { limit: 25, sort: "-published_at" };

    queryObject = Object.assign(
      queryObject,
      this.$router.history.current.query
    );

    this.$store.commit("search/setQueryObject", queryObject);

    if(!this.firstQuote){
      let responses = await Promise.all([
        this.search(),
        this.$axios.get("quotes?sort=random&filter[daily]=true")
      ])
      this.quote = responses[1].data.data[0];
      this.firstQuote = true
    } else {
      await this.search()
    }

  },
  methods: {
    authors(pArray) {
      if (pArray.collaborators) {
        return pArray.collaborators.filter(function(item) {
          return item.type === "author" && item.name !== "";
        });
      } else {
        return [];
      }
    },
    editors(pArray) {
      if (pArray.collaborators) {
        return pArray.collaborators.filter(function(item) {
          return item.type === "editor" && item.name !== "";
        });
      } else {
        return [];
      }
    },
      //scroll fetch method
    getQueryString(){
      const queryObject = this.queryObject;
      queryObject.sort = "-published_at";
      queryObject.limit = 25

      this.$store.commit("search/setQueryObject", queryObject);

      return decodeURIComponent(
        this.$createQueryString(queryObject)
      );
    },
    getMainImgObj(item) {
      // if (article.images && article.images.length) {
      //   return article.images[0].url
      // }
      if (item.thumbnail && item.thumbnail.photo) {
         return { 
          mime_type:"image/jpeg",
          url: item.thumbnail.photo.url + item.thumbnail.photo.name
         } 
      }
      return null;
    },
    searchChanged(queryObject) {
      this.$router.push({ query: queryObject });
    },
    findSidebarModule(name){
      let settings = this.$store.state.settings
      let order = settings['OPTIONS_INDEX_SIDEBAR_ORDER'].value.order;
      let index = order.findIndex(item => item === name)
      return index === -1 ? null : index
    }
  }
};
</script>
